import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ImportDeclarationService } from './../../services/import-declaration.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DatePipe } from '@angular/common';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { noFullWidthValidator } from 'src/app/core/utils/validation-functions';

@Component({
  selector: 'laas-import-header-edit',
  templateUrl: './import-header-edit.component.html',
  styleUrls: ['./import-header-edit.component.scss']
})
export class ImportHeaderEditComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: string;
  importHeader: any;
  editForm: FormGroup;
  forwarderOptions: any[];
  billObjectTypeOptions: any[];
  billObjectOptions: any[];
  orgIdOptions: any[];
  billCorpOptions: any[];
  incoTermOptions: any[];
  vendorOptions: any[];
  importTypeOptions: any[];
  docTypeOptions: any[];
  currencyOptions: any[];
  countryOptions: any[];
  cityOptions: any[];
  submitted: boolean;

  constructor(
    injector: Injector,
    private importDeclarationService: ImportDeclarationService,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.permissionCode = PermissionConstants.ViewImportDeclaration;
    this.forwarderOptions = [];
    this.billObjectTypeOptions = [];
    this.billObjectOptions = [];
    this.orgIdOptions = [];
    this.billCorpOptions = [];
    this.incoTermOptions = [];
    this.vendorOptions = [];
    this.importTypeOptions = [];
    this.docTypeOptions = [];
    this.currencyOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.submitted = false;
    this.importHeader = {
      forwarder: '',
      billObjectType: '',
      billObject: '',
      orgId: '',
      billCorp: '',
      whNo: '',
      docNo: '',
      docNo1: '',
      docNo2: '',
      docNo3: '',
      docNo4: '',
      docNo5: '',
      apInvoiceId: '',
      apglDtTimeZone: '',
      incoTerm: '',
      vendor: '',
      importDtTimeZone: '',
      importType: '',
      expressBill: '',
      mawbNo: '',
      docType: '',
      currency: '',
      exportCountryCode: '',
      exportCityCode: '',
      gvTaxNo: '',
      gvTaxDtTimeZone: '',
      importRate: null,
      importAmount: null,
      importAmountTax: null,
      importAcctdAmount: null,
      importAcctdAmountTax: null,
      estimatedGvAcctdAmount: null,
      estimatedGvAcctdAmountTax: null,
      estimatedGvAcctdExpBAmount: null,
      estimatedGvAcctdExpCAmount: null,
      estimatedGvAcctdExpDAmount: null,
      reference: '',
      applyNo: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    };

    this.editForm = this.formBuilder.group({
      forwarder: ['', Validators.required],
      billObjectType: ['', Validators.required],
      billObject: ['', Validators.required],
      orgId:'',
      billCorp: '',
      whNo: '',
      docNo: '',
      docNo1: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo2: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo3: ['', [Validators.maxLength(2), noFullWidthValidator()]],
      docNo4: ['', [Validators.maxLength(4), noFullWidthValidator()]],
      docNo5: ['', [Validators.maxLength(5), noFullWidthValidator()]],
      apInvoiceId: '',
      apglDtTimeZone: '',
      incoTerm: ['', Validators.required],
      vendor: '',
      importDtTimeZone: '',
      importType: ['', Validators.required],
      expressBill: ['', Validators.required],
      mawbNo: '',
      docType: ['', Validators.required],
      currency: '',
      exportCountryCode: ['', Validators.required],
      exportCityCode: ['', Validators.required],
      gvTaxNo: '',
      gvTaxDtTimeZone: '',
      importRate: null,
      importAmount: null,
      importAmountTax: null,
      importAcctdAmount: null,
      importAcctdAmountTax: null,
      estimatedGvAcctdAmount: null,
      estimatedGvAcctdAmountTax: null,
      estimatedGvAcctdExpBAmount: null,
      estimatedGvAcctdExpCAmount: null,
      estimatedGvAcctdExpDAmount: null,
      reference: '',
      applyNo: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    });
  }

  get f(): any { return this.editForm.controls; }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    const importDeclarationNo = this.routeStateService.getCurrent().data.importDeclarationNo;

    try{
      this.importHeader = await this.importDeclarationService.getImportHeaderDetail(importDeclarationNo);
      console.log('importHeader', this.importHeader);
      const docNoArr = this.importHeader?.docNo.split('/');

      docNoArr.forEach((element: string, index: number) => {
        this.importHeader['docNo' + (index + 1).toString()] = element;
        if (index === 1 && isNullOrEmpty(element)) {
          this.importHeader['docNo' + (index + 1).toString()] = '　';
        }
      });

      this.importHeader.apglDtTimeZone = this.datePipe.transform(this.importHeader.apglDt, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
      this.importHeader.importDtTimeZone = this.importHeader.importDt != null ?
          this.datePipe.transform(this.importHeader.importDt, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone) :
          this.datePipe.transform(new Date(), 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
      this.importHeader.gvTaxDtTimeZone = this.datePipe.transform(this.importHeader.gvTaxDt, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
      this.importHeader.currency = this.importHeader.currency != null ? this.importHeader.currency : 'USD';
    }catch (err: any) {
      console.log('get import header occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.importHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.forwarderOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.billObjectTypeOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getBillObjectOptions(this.importHeader.facility, this.importHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.importHeader.facility, '').subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityReferenceCode}-${x.legalEntityOUName}(${x.legalEntityOUCode})`,
            value: x.legalEntityOUCode,
          };
        });
        this.orgIdOptions.unshift({
          label: '請選擇',
          value: ''
        });
        if ([...result].filter(x => x.legalEntityOUCode === this.importHeader.orgId && x.billOUCode !== null).length > 0){
          this.billCorpOptions = [...result]
              .filter(x => x.legalEntityOUCode === this.importHeader.orgId && x.billOUCode != null).map((x: any) => {
                return {
                  label: `${x.billReferenceCode}-${x.billOUName}(${x.billOUCode})`,
                  value: x.billOUCode,
                };
          });
          this.billCorpOptions.unshift({
            label: '請選擇',
            value: ''
          });
        }
        else{
          this.billCorpOptions = [...result].filter(x => x.billOUCode !== null).map((x: any) => {
            return {
              label: `${x.billReferenceCode}-${x.billOUName}(${x.billOUCode})`,
              value: x.billOUCode,
            };
          });
          this.billCorpOptions.unshift({
            label: '請選擇',
            value: ''
          });
        }
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.incoTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.dropdownOptionsService.getVendorOptions(this.importHeader.vendor).subscribe({
      next: result => {
        this.vendorOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getImportTypeOptions().subscribe({
      next: result => {
        this.importTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.importTypeOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.docTypeOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.currencyOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
        this.countryOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityOptions = [...result].filter(x => x.country === this.importHeader.exportCountryCode).map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
          };
        });
        this.cityOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  changeBillObject(): void {
    const billObjectType = this.importHeader.billObjectType;

    if (billObjectType === 'V'){
      this.importHeader.billObject = '76';
    } else if (billObjectType === 'E') {
      this.importHeader.billObject = '';
    }

    this.facilityService.getBillObjectOptions(this.importHeader.facility, this.importHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });
  }

  changeCityOptions(): void {
    this.facilityService.getCityOptions().subscribe({
      next: result => {
        const exportCountryCode = this.importHeader.exportCountryCode;
        this.cityOptions = [...result].filter(x => x.country === exportCountryCode).map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
          };
        });
        this.cityOptions.unshift({
          label: '請選擇',
          value: ''
        });
        this.importHeader.exportCityCode = this.cityOptions[1].value;
      }
    });
  }

  getVendorOptions(event: any): void {
    const key: string = event.filter;
    const currentOption = this.vendorOptions.find(x => x.value === this.importHeader.vendor);

    if (key != null && key.length > 0 ){
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: result => {
          this.vendorOptions = [...result].map((x: any) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          });
          this.vendorOptions.unshift(currentOption);
        }
      });
    }
  }

  handleString(str: string): string{
    return isNullOrEmpty(str) ? '' : str;
  }

  saveBtnClick(event: any): void{
    this.submitted = true;
    if (this.editForm.invalid) {
      this.toastService.warn('請檢查是否有必填欄位尚未填寫');
      return;
    }

    //docNo & DateTime convert
    this.importHeader.docNo = `${this.handleString(this.importHeader.docNo1)}/${this.handleString(this.importHeader.docNo2)}/${this.handleString(this.importHeader.docNo3)}/${this.handleString(this.importHeader.docNo4)}/${this.handleString(this.importHeader.docNo5)}`;
    this.importHeader.apglDt = isNullOrEmpty(this.importHeader.apglDtTimeZone) ? null : new Date(this.importHeader.apglDtTimeZone).toISOString();
    this.importHeader.importDtTimeZone = isNullOrEmpty(this.importHeader.importDtTimeZone) ? this.datePipe.transform(new Date(), 'yyyy/MM/dd', this.laasSetting.facilityTimeZone) : this.importHeader.importDtTimeZone;
    this.importHeader.importDt = new Date(this.importHeader.importDtTimeZone).toISOString();
    this.importHeader.gvTaxDt = isNullOrEmpty(this.importHeader.gvTaxDtTimeZone) ? null : new Date(this.importHeader.gvTaxDtTimeZone).toISOString();
    this.importHeader.updateUser = this.userProfile.userName;

    this.importDeclarationService.updateImportDetail(this.importHeader).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                const resultObj = {
                  importDeclarationNo: [this.importHeader.importDeclarationNo]
                };
                this.routeStateService.navigateTo('/TransportOperation/ImportSearch', resultObj);
              }
            });
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
        this.ngOnInit();
      }
    });
  }

  goToLastPage(): void{
    this.routeStateService.loadPrevious();
  }
}
